<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <div
          class="font-weight-medium ml-5"
          style="font-size: 20px"
        >
          List of Stocks
        </div>
      </v-col>
    </v-row>
      
    <v-card>
      <v-container fluid class="pa-5">
        <v-form @submit="getStockList">
          <v-row>
            <v-col cols="12">
              <v-menu v-model="isSearchMenuOpen" :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on, value }">
                  <v-text-field
                    v-model="searchStocks"
                    label="Search stocks by name, RIC, Ticker or Isin"
                    class="purple-input"
                  >
                    <template slot="append">
                      <div class="d-flex">
                        <v-tooltip v-if="searchStocks" z-index="10" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn 
                              icon
                              v-on="on"
                              @click="resetSearchForm(), getStockList($event)"
                            >
                              <v-icon
                                small
                                v-text="'mdi-close'"
                              ></v-icon>
                            </v-btn>
                          </template>
                          <span>Clear Search</span>
                        </v-tooltip>

                        <v-tooltip z-index="10" bottom>
                          <template v-slot:activator="{ on: onTooltip }">
                            <v-btn 
                              icon
                              v-on="{...on, ...onTooltip}"
                            >
                              <v-icon
                                v-text="value ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                              ></v-icon>
                            </v-btn>
                          </template>

                          <span 
                            v-text="(isSearchMenuOpen ? 'Hide' : 'Show') + ' Search Options'"
                          ></span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-text-field>
                </template>

                <v-card class="pa-5">
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <p>Exposure to Factors</p>

                      <v-row v-for="item in styles" :key="item.code" style="margin: 0px;">
                        <v-col cols="4" style="font-weight: bold; color: #00bfc5; margin-top: 17px; padding: 0px;">
                          {{item.factor}}
                        </v-col>
                        <v-col cols="8" style="margin-left: -20px; padding: 0px;">
                          <v-btn-toggle
                            v-model="factors[item.code]"
                            tile
                            color="primary"
                            group
                            multiple
                          >
                            <v-btn value="low">
                              Low
                            </v-btn>
                            <v-btn value="avg">
                              Avg
                            </v-btn>
                            <v-btn value="high">
                              High
                            </v-btn>
                          </v-btn-toggle>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="sector"
                            :items="sectors"
                            item-text="sector"
                            item-value="code"                
                            label="Sector"
                            multiple
                            chips
                          >
                            <template v-slot:prepend-item>
                              <v-list-item
                                ripple
                                @click="toggleAllSector"
                              >
                                <v-list-item-action>
                                  <v-icon :color="sector.length > 0 ? 'indigo darken-4' : ''">{{ iconSector }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>              
                          </v-select>

                          <v-select
                            v-model="currency"
                            :items="currencies"
                            item-text="currency"
                            item-value="currency"                
                            label="Currency"
                            multiple
                            chips
                          >
                            <template v-slot:prepend-item>
                              <v-list-item
                                ripple
                                @click="toggleAllCurrency"
                              >
                                <v-list-item-action>
                                  <v-icon :color="currency.length > 0 ? 'indigo darken-4' : ''">{{ iconCurrency }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="country"
                            :items="countries"
                            item-text="name"
                            item-value="country"                     
                            label="Country"
                            multiple
                            chips
                          >
                            <template v-slot:prepend-item>
                              <v-list-item
                                ripple
                                @click="toggleAllCountry"
                              >
                                <v-list-item-action>
                                  <v-icon :color="country.length > 0 ? 'indigo darken-4' : ''">{{ iconCountry }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>           
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                          clearable
                            v-model="sortParam"
                            :items="sortParams"
                            item-text="text"
                            item-value="value"                     
                            label="Sort by"
                            chips
                          >           
                          </v-select>
                        </v-col>

                          <v-col
                            cols="12"
                            class="text-right"
                          >
                            <v-btn
                              color="primary"
                              class="mr-3"
                              type="submit"
                              @click="getStockList($event), isSearchMenuOpen = false"
                              :loading="buttonLoading"
                            >
                              Search
                            </v-btn>
                            <v-btn
                              color="primary"
                              outlined
                              class="mr-0"
                              @click="resetSearchForm()"
                            >
                              Reset
                            </v-btn>
                          </v-col>
                      </v-row>  
                    </v-col>
                  </v-row>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-5">
      <v-container fluid class="pa-5">


        <v-row>
          <v-col cols="12">
            <p>Search Results</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="auto">
            <small>{{count}} found {{((items.length  === count) ? '' : ' - only ' + items.length + ' displayed')}} </small>
          </v-col>        
          <v-spacer></v-spacer>
          <v-col cols="12" md="auto">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Filter"
              single-line
              hide-details
              style="max-width: 250px;"
              class="float-right"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-overlay
              :absolute="absolute"
              :opacity="opacity"
              :value="overlay"
            >
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>            
            <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
            <v-data-table
              v-show="!listLoad"
              :headers="headers"
              :items="items"
              :search.sync="search"
              :mobile-breakpoint="0"
            >
              <template v-slot:[`header.market_cap`]>
               <span class="text-no-wrap"> Market Cap  </span> <br> (loc ccy)
              </template>
              <template v-slot:item="row">
                <tr>
                  <td class="sm">
                    <v-btn
                      class="px-2 mr-2"
                      color="primary"
                      min-width="0"
                      icon
                      small
                      :to="'/stocks/analyze/' + row.item.ric"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            mdi-magnify-plus-outline
                          </v-icon>                        
                        </template>
                        <span>Analyze</span>
                      </v-tooltip> 
                    </v-btn>
                  </td>
                  <td>{{ row.item.name }}</td>
                  <td>{{ row.item.ticker }}</td>
                  <td>{{ row.item.ric }}</td>
                  <td>{{ row.item.isin }}</td>
                  <td class="text-right">
                    <span class="px-4">
                      {{ row.item.market_cap | numeral('0.00a') }}
                    </span>
                  </td>
                  <td class="text-right">{{ row.item.sector }}</td>
                  <td class="text-center">{{ row.item.country }}</td>
                  <td>{{ row.item.Value }}</td>
                  <td>{{ row.item.Momentum }}</td>
                  <td>{{ row.item.Risk }}</td>
                  <td>{{ row.item.Size }}</td>
                  <td>{{ row.item.Quality }}</td> 
                  <td class="text-right">
                    <span class="px-4">
                      {{ row.item.potential_days_to_trade }}
                    </span>
                  </td> 
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-snackbar
      v-model="errorbar"
    >
      An error has occurred/No filters found
      <v-btn
        color="pink"
        text
        @click="errorbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>    
  </v-container>
</template>

<script>
  export default {
    name: 'appStocksList',
    data() {
      return {
        count:0,
        absolute: true,
        opacity: 0.46,
        overlay: false,        
        factors: {
        },
        searchStocks: '',
        sector: [],
        currency: [],
        country: [],
        styles :[],
        countries :[],
        sectors:[],
        currencies:[],
        states: [
        ],
        search: '',
        isSearchMenuOpen: false,
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'Ticker', value: 'ticker' },
          { text: 'RIC', value: 'ric' },
          { text: 'ISIN', value: 'isin' },
          { text: 'Market Cap (loc ccy)', value: 'market_cap', align: 'right' },
          { text: 'Sector', value: 'sector', align: 'right' },
          { text: 'Country', value: 'country', align: 'center' },
          { text: 'Value', value: 'Value' },
          { text: 'Momentum', value: 'Momentum' },
          { text: 'Low Risk', value: 'Risk' },
          { text: 'Small Size', value: 'Size' },                                        
          { text: 'Quality', value: 'Quality' },    
          { text: 'Days to Trade', value: 'potential_days_to_trade', align: 'right'},    
        ],
        items: [],
        listLoad: true,
        errorbar: false,
        buttonLoading: false,
        sortParams:[
          { text: 'Potential Days to Trade - Desc', value: 'daystotradeDesc' },
          { text: 'Potential Days to Trade - Asc', value: 'daystotradeAsc' },
          { text: 'Market Cap', value: 'marketcap' },                                                
        ],
        sortParam: null
      }
    },
    mounted () {
      this.getFiltersFromApi()
      this.getListFromApi(null)
    },
    computed: {
      likesAllSectors () {
        return this.sector.length === this.sectors.length
      },
      likesSomeSectors () {
        return this.sector.length > 0 && !this.likesAllSectors
      },
      iconSector () {
        if (this.likesAllSectors) return 'mdi-close-box'
        if (this.likesSomeSectors) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },

      likesAllCountries () {
        return this.country.length === this.countries.length
      },
      likesSomeCountries () {
        return this.country.length > 0 && !this.likesAllCountries
      },
      iconCountry () {
        if (this.likesAllCountries) return 'mdi-close-box'
        if (this.likesSomeCountries) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      
      likesAllCurrencies () {
        return this.currency.length === this.currencies.length
      },
      likesSomeCurrencies () {
        return this.currency.length > 0 && !this.likesAllCurrencies
      },
      iconCurrency () {
        if (this.likesAllCurrencies) return 'mdi-close-box'
        if (this.likesSomeCurrencies) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      }      
    },    
    methods: {
      toggleAllSector () {
        this.$nextTick(() => {
          if (this.likesAllSectors) {
            this.sector = []
          } else {
            this.sector = this.sectors.slice()
          }
        })
      },      
      toggleAllCountry () {
        this.$nextTick(() => {
          if (this.likesAllCountries) {
            this.country = []
          } else {
            this.country = this.countries.slice()
          }
        })
      },   
      toggleAllCurrency () {
        this.$nextTick(() => {
          if (this.likesAllCurrencies) {
            this.currency = []
          } else {
            this.currency = this.currencies.slice()
          }
        })
      },               
      async getFiltersFromApi () {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-stocks-list-filter',{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.styles = response.data.style
          self.countries= response.data.country
          self.sectors= response.data.sector
          self.currencies= response.data.currency
          self.listLoad = false
        }).catch(function () {
          self.listLoad = false
          self.errorbar = true
        })
      },
      getStockList(e) {
        e.preventDefault();        
        let bodyFilter = {
          text: this.searchStocks,
          factor :this.factors,
          sectors :this.sector,
          countries :this.country,
          currencies :this.currency,
          sort: this.sortParam,
        }          
        //console.log(bodyFilter)
        this.getListFromApi(bodyFilter)
        //this.overlay=false
      },            
      async getListFromApi(filter) {
        var self = this
        self.buttonLoading=true
        self.overlay=true        
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-stocks-list',filter,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.items = response.data.list
          self.count = response.data.count
          self.listLoad = false
          self.buttonLoading=false
          self.overlay=false          
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          //self.errorbar = true
          self.buttonLoading=false
          self.overlay=false
        })
      },
      // analyzeStock (item) {
      //   this.$router.push({ path: `/stocks/analyze/${item}` })
      // },
      resetSearchForm () {
        this.searchStocks = ''
        this.sector = []
        this.country = []
        this.currency = ''
        this.factors= {}
        this.sortParam = null
      }
    }
  }
</script>

<style
  scoped
>
  td {
    min-width: 150px;
  }
  td.sm {
    min-width: 50px;
  }
</style>